export default __webpack_public_path__ + "media/src/assets/images/Autograph-c4c3926c7adea67216b4245eb4033ca7.svg";